"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitFlagsUtils = void 0;
/**
 * Bit flags utilities
 */
var BitFlagsUtils;
(function (BitFlagsUtils) {
    function hasFlag(currentValue, expectedFlag) {
        return (currentValue & expectedFlag) == expectedFlag;
    }
    BitFlagsUtils.hasFlag = hasFlag;
    function getMatchingFlags(type, value) {
        return getEnumFlags(type)
            .filter(x => hasFlag(value, x.flag));
    }
    BitFlagsUtils.getMatchingFlags = getMatchingFlags;
    function getEnumFlags(type) {
        return Object.entries(type)
            .filter(x => typeof x[0] === "string" && typeof x[1] === "number")
            .map(x => ({ name: x[0], flag: x[1] }));
    }
    BitFlagsUtils.getEnumFlags = getEnumFlags;
})(BitFlagsUtils = exports.BitFlagsUtils || (exports.BitFlagsUtils = {}));
//# sourceMappingURL=flags.js.map